import { render } from "./studioManage.vue?vue&type=template&id=152f7982&scoped=true"
import script from "./studioManage.vue?vue&type=script&lang=js"
export * from "./studioManage.vue?vue&type=script&lang=js"

import "./studioManage.vue?vue&type=style&index=0&id=152f7982&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-152f7982"]])

export default __exports__